// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3D4_E","name":"ConsentHeader_name__1vZYe","birthday":"ConsentHeader_birthday__3N0fZ","skeleton":"ConsentHeader_skeleton__2kj6k"};